import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_2 = { class: "inline-block min-w-full py-2 align-middle md:px-6 lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Item")
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "font-semibold text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "text-gray-600" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Price")
const _hoisted_8 = { class: "text-gray-600 whitespace-nowrap" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Status")
const _hoisted_10 = { class: "text-gray-500 whitespace-nowrap" }
const _hoisted_11 = ["onClick", "disabled"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Acknowledge ")
const _hoisted_13 = {
  key: 1,
  class: "text-gray-500 inline-flex items-center"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Confirmed ")
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "py-8 text-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 font-medium text-gray-900" }, "You are up to date!", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-sm" }, " New orders and hold requests will show up here. ", -1)

import { useOrders } from "@/composables/orders";
import { computed, ref, Ref } from "vue";
import DefaultTable from "@/components/DefaultTable.vue";
import OrderStatusBadge from "@/components/OrderStatusBadge.vue";
import { formatDistanceToNow, parseISO } from "date-fns";
import { CheckIcon, ClipboardCheckIcon } from "@heroicons/vue/solid";
import TableSkeleton from "@/components/skeletons/TableSkeleton.vue";
import { useFulfilment } from "@/composables/fulfilment";
import { useVendor } from "@/composables/vendor";
import Spinner from "@/components/Spinner.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { orders: allOrders, isReady, isLoading, refresh } = useOrders();
const { client } = useFulfilment();
const { currentVendor } = useVendor();

const actionContext = {} as Record<
  string,
  Ref<{
    isLoading: boolean;
    result: any;
    error: any;
  }>
>;

const useAction = (key: string) => {
  if (!actionContext[key]) {
    actionContext[key] = ref({
      isLoading: false,
      result: undefined,
      error: undefined,
    });
  }

  return actionContext[key];
};

const orders = computed(() =>
  allOrders.value.filter((val) => !val.supplierStatus)
);

const doConfirmOrder = async (order: any) => {
  const action = useAction(order.id);

  action.value.isLoading = true;

  try {
    console.log("Confirming order", { order });
    const response = await client.value!.post(`/fulfilment/items/update`, {
      supplier: currentVendor.value!.shortname,
      records: [
        {
          id: order.id,
          update: {
            supplierStatus: "CONFIRMED",
          },
        },
      ],
    });

    await refresh();

    action.value.result = "ok";
    action.value.error = null;
  } catch (error) {
    action.value.isLoading = false;
  }
};

// const updateConfirmationStatus = async (item: any) => {
//   console.log("Updating confirmationStatus...", { item });

//   let response = await client.value!.post(`/fulfilment/items/update`, {
//     supplier: currentVendor.value!.shortname,
//     records: [
//       {
//         id: item.id,
//         update: {
//           supplierStatus: "CONFIRMED",
//         },
//       },
//     ],
//   });

//   refreshDashboardItems();

//   return response.data.records[0];
// };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_unref(isReady) || _unref(isLoading))
        ? (_openBlock(), _createBlock(TableSkeleton, { key: 0 }))
        : (_unref(orders).length > 0)
          ? (_openBlock(), _createBlock(DefaultTable, {
              key: 1,
              columns: ['name', 'cost', 'status', 'time', 'action'],
              rows: _unref(orders)
            }, {
              "th-name": _withCtx(() => [
                _hoisted_3
              ]),
              "td-name": _withCtx(({ row: order }) => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(order.name), 1),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(order.supplier) + " " + _toDisplayString(order.origin) + " " + _toDisplayString(order.supplierRef), 1)
                ])
              ]),
              "th-cost": _withCtx(() => [
                _hoisted_7
              ]),
              "td-cost": _withCtx(({ row: order }) => [
                _createElementVNode("span", _hoisted_8, " $" + _toDisplayString(order.costPriceUsd) + " USD ", 1)
              ]),
              "th-status": _withCtx(() => [
                _hoisted_9
              ]),
              "td-status": _withCtx(({ row: order }) => [
                _createVNode(OrderStatusBadge, {
                  value: order.status
                }, null, 8, ["value"])
              ]),
              "td-time": _withCtx(({ row: order }) => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formatDistanceToNow)(_unref(parseISO)(order.updatedAt), {
                addSuffix: true,
              })), 1)
              ]),
              "td-action": _withCtx(({ row: order }) => [
                (!useAction(order.id).value.result)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                      onClick: ($event: any) => (doConfirmOrder(order)),
                      disabled: useAction(order.id).value.isLoading
                    }, [
                      _hoisted_12,
                      (useAction(order.id).value.isLoading)
                        ? (_openBlock(), _createBlock(Spinner, {
                            key: 0,
                            class: "w-4 h-4 ml-2"
                          }))
                        : (_openBlock(), _createBlock(_unref(CheckIcon), {
                            key: 1,
                            class: "w-4 h-4 ml-2"
                          }))
                    ], 8, _hoisted_11))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_unref(CheckIcon), { class: "w-4 h-4 ml-2" })
                    ]))
              ]),
              _: 1
            }, 8, ["rows"]))
          : (_unref(orders).length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_unref(ClipboardCheckIcon), { class: "text-gray-400 w-8 h-8 block mx-auto" }),
                  _hoisted_17,
                  _hoisted_18
                ])
              ]))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})